import { TextField, useTheme, useMediaQuery, styled } from "@mui/material";

export const InputField = styled(TextField)(({ theme }) => ({
    "& .MuiInputBase-root.MuiInputBase-root": {
        // borderRadius: "5rem",
    },
    
    "& .MuiInputBase-root input": { padding: "6px 8px" },
}));